import React, { FC } from 'react';
import { grayBorderStyle } from '../ColorsFilter.constants';
import { ColorFilterNode } from '../ColorFilterNode';
import styles from './BlackWhiteColorsFilterNode.scss';
import { IOuter } from './BlackWhiteColorsFilterNode.types';

export const BlackWhiteColorsFilterNode: FC<IOuter> = ({ onClick, isSelected }) => (
  <ColorFilterNode onClick={onClick} isSelected={isSelected} innerCircleStyle={grayBorderStyle}>
    <span className={styles.circle} />
  </ColorFilterNode>
);
